/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Kiotviet_Unlinked_Filter_AllInputs */

const vi_order_kiotviet_unlinked_filter_all = /** @type {(inputs: Order_Kiotviet_Unlinked_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả`)
};

/**

* @param {Order_Kiotviet_Unlinked_Filter_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_kiotviet_unlinked_filter_all = /** @type {((inputs?: Order_Kiotviet_Unlinked_Filter_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Kiotviet_Unlinked_Filter_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_kiotviet_unlinked_filter_all(inputs)
});